import { calendarDateFromStorage } from '../utils/calendar-date'

// Storage semantics, deliberately independent of display column types (some
// audit timestamps are displayed as DATE). Never infer from midnight/noon.
const CALENDAR_FIELDS: Readonly<Record<string, readonly string[]>> = {
  CONTACT: ['birthday'],
  PROJECT: ['startDate', 'endDate'],
  DEAL: ['closeDate', 'expectedStartDate'],
  CONTRACT: [
    'startDate',
    'endDate',
    'renewalDueDate',
    'reminderDate',
    'billingTermsStartDate',
  ],
  INVOICE: ['issueDate', 'dueDate'],
  TIME_ENTRY: ['entryDate'],
  TASK: ['recurringEndDate', 'nextRecurrenceDate'],
}

export function formulaCalendarFieldValue(value: unknown): string | null {
  return value instanceof Date || typeof value === 'string'
    ? calendarDateFromStorage(value) || null
    : null
}

/** Calendar semantics come from the field contract, including independent task flags. */
export function standardFieldDateMode(
  moduleType: string,
  fieldName: string,
): 'calendar' | 'instant' | 'task-schedule' | 'task-due' {
  if (CALENDAR_FIELDS[moduleType]?.includes(fieldName)) return 'calendar'
  if (moduleType === 'TASK' && fieldName === 'scheduledFor')
    return 'task-schedule'
  if (moduleType === 'TASK' && fieldName === 'dueDate') return 'task-due'
  return 'instant'
}

export function formulaStandardFieldValue(
  moduleType: string,
  fieldName: string,
  row: Record<string, unknown>,
  value: unknown,
): unknown {
  const mode = standardFieldDateMode(moduleType, fieldName)
  const dateOnly =
    mode === 'calendar' ||
    (mode === 'task-schedule' && row.isAllDay === true) ||
    (mode === 'task-due' && row.dueDateHasTime === false)
  return dateOnly ? formulaCalendarFieldValue(value) : value
}
